"use client";

import {
  Alert,
  AlertTitle,
  Backdrop,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import CustomAccordion from "./Ui/CustomAccordion";
import Face6Icon from "@mui/icons-material/Face6";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import ListIcon from "@mui/icons-material/List";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import HandshakeIcon from "@mui/icons-material/Handshake";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { useState } from "react";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
import { useBusinessContext } from "../../context/business-context";
import { set } from "react-hook-form";

// import CustomAccordion from "./custom-accordion";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  getMotherLedgers?: () => void;
  ledgerMothersType: any[];
  branchList: any[];
  getMotherComp?: any[];
};

export default function LedgerSubHeadModal({
  isOpen,
  onClose,
  ledgerMothersType,
  branchList,
  getMotherComp,
  getMotherLedgers
}: // onGetactivationList,
Props) {
  const [email, setEmail] = useState("");
  const [branch, setBranch] = useState("");
  const [subheadingType, setSubheadingType] = useState("");
  const [mainheadingType, setMainheadingType] = useState("");
  const [ledgerMainHead, setLedgerMainHead] = useState("");
  const [ledgerSubHead, setLedgerSubHead] = useState("");
  const [ledgerType, setLedgerType] = useState("motherComp");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");

  const { selectedBusinessId } = useBusinessContext();

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const onGenerateCode = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      formData.append("branch_id", branch);
      formData.append("email", email);
      formData.append("roleID", role);

      const response = await axios.post(
        baseUrl() + "businesss/generateInviteCode",
        formData,
        config
      );
      console.log(response);
      const data = await response.data;

      onClose();
      setEmail("");
      setBranch("");
      setRole("");
      setAlertMsg(data.message || "Code generated successfully.");
      onShowAlert();
      // onGetactivationList();
      setStatus({ loading: false, error: false });
      //   onGetactivationList()
    } catch (error) {
      setStatus({ loading: false, error: true });
      console.log(error);
      setAlertMsg(error.response.data.message || "An error occurred.");
      onShowAlert();
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  const onAddLedger = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      formData.append("mother_id", subheadingType);
      formData.append("setupType", ledgerType);
      formData.append("motherComp", mainheadingType);
      if (ledgerType == "motherSub") {
        formData.append("branch_id", branch);
        formData.append("motherSub", ledgerSubHead);
      }


      
      const response = await axios.post(
        baseUrl() + "ledgercreates/addLedgerHead_Subhead",
        formData,
        config
      );
      console.log(response)
      const data = await response.data;

      if (data.status == "true") {
        setAlertMsg(data.message || "Code generated successfully.");
        setLedgerMainHead('')
        setMainheadingType('')
        setLedgerSubHead('')
        onShowAlert();
        // onGetactivationList();
        setStatus({ loading: false, error: false });
      }
      onClose();
        getMotherLedgers()
    } catch (error) {
      setStatus({ loading: false, error: true });
      console.log(error);
      setAlertMsg(error.response.data.message || "An error occurred.");
      onShowAlert();
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: 600,
          width: 900,
          bgcolor: "white",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center", m: 3 }}>
          Add Ledger Headings
        </Typography>

        {showAlert && (
          <Alert severity={status.error ? "error" : "success"}>
            <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}
          </Alert>
        )}

        {/* Branch Select */}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Select Ledger Mother Type</InputLabel>
          <Select
            value={subheadingType}
            label="Sub heading Type"
            onChange={(e) => setSubheadingType(e.target.value)}
          >
            {ledgerMothersType?.map((ledger, index) => (
              <MenuItem key={index} value={ledger.motherID}>
                {ledger.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <RadioGroup
            row
            value={ledgerType}
            onChange={(e) => {setLedgerType(e.target.value),setMainheadingType('')}}
          >
            <FormControlLabel
              value="motherComp"
              control={<Radio />}
              label="Main Heading"
            />
            <FormControlLabel
              value="motherSub"
              control={<Radio />}
              label="Subheading"
            />
          </RadioGroup>
        </FormControl>

        {/* Conditional Fields Based on Selection */}
        {ledgerType === "motherComp" && (
          <TextField
            fullWidth
            label="Enter Main Heading"
            variant="outlined"
            value={mainheadingType}
            onChange={(e) => setMainheadingType(e.target.value)}
            sx={{ my: 2 }}
          />
        )}

        {ledgerType === "motherSub" && (
          <>
            {/* Select Main Heading */}
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Select Main Heading</InputLabel>
              <Select
                value={mainheadingType}
                label="Select Main Heading"
                onChange={(e) => setMainheadingType(e.target.value)}
              >
                {getMotherComp
                  ?.filter(
                    (motherComp) => motherComp.motherID === subheadingType
                  )
                  .map((ledger, index) => (
                    <MenuItem key={index} value={ledger.compID}>
                      {ledger.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            {/* Enter Subheading */}
            <TextField
              fullWidth
              label="Enter Subheading"
              variant="outlined"
              value={ledgerSubHead}
              onChange={(e) => setLedgerSubHead(e.target.value)}
              sx={{ my: 2 }}
            />

            {/* Select Branch */}
        {/*     <FormControl fullWidth>
              <InputLabel>Select Branch</InputLabel>
              <Select
                value={branch}
                label="Select Branch"
                onChange={(event) => setBranch(event.target.value)}
              >
                {branchList?.map((branchItem, i) => (
                  <MenuItem key={i} value={branchItem.branch_id}>
                    {branchItem.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </>
        )}

        {/* Email Input */}
        {/* <TextField
          fullWidth
          label="Enter Main Heading"
          // type="email"
          variant="outlined"
          value={ledgerMainHead}
          onChange={(e) => setLedgerMainHead(e.target.value)}
          sx={{ my: 2 }}
        />

        <TextField
          fullWidth
          label="Enter Subheading"
          // type="email"
          variant="outlined"
          value={ledgerSubHead}
          onChange={(e) => setLedgerSubHead(e.target.value)}
          sx={{ my: 2 }}
        /> */}

        {/* <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Branch:</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={branch}
            label="Ledger Type"
            onChange={(event) => {
              setBranch(event.target.value);
            }}
          >
            {branchList?.map((branchList, i) => {
              return (
                <MenuItem key={i} value={branchList.id}>
                  {branchList.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl> */}

        <Button
          variant="contained"
          sx={{ mt: 4 }}
          onClick={onAddLedger}
          disabled={!subheadingType || !mainheadingType}
        >
          {status.loading ? "Loading..." : "Submit"}
        </Button>

        {/* Close Button */}
        <Button variant="outlined" sx={{ mt: 4, ml: 2 }} onClick={onClose}>
          Close
        </Button>
      </Box>
    </Modal>
  );
}
